import { sha256Hex } from '@myplayer/gs1';
export const AUDIT_CHAIN_GENESIS_PREV_HASH = 'GENESIS';
export const AUDIT_CHAIN_HEAD_COLLECTION = 'auditChainState';
export const AUDIT_CHAIN_HEAD_DOC_ID = '_chainHead';
function canonicalizeAuditValue(value) {
    if (value === null || value === undefined) {
        return null;
    }
    if (Array.isArray(value)) {
        return value.map((item) => canonicalizeAuditValue(item));
    }
    if (typeof value === 'object') {
        const obj = value;
        const sortedKeys = Object.keys(obj).sort();
        const out = {};
        for (const k of sortedKeys) {
            const v = obj[k];
            if (v !== undefined) {
                out[k] = canonicalizeAuditValue(v);
            }
        }
        return out;
    }
    return value;
}
/**
 * Computes a deterministic SHA-256 hash (`entryHash`) over the canonical fields of an
 * append-only audit log entry and its `sequence` + `prevHash`.
 * Shared across Cloud Functions, Partner API, and Admin UI client verification.
 */
export function computeCanonicalAuditEntryHash(params) {
    const { entry, sequence, prevHash } = params;
    const canonicalPayload = JSON.stringify({
        auditId: entry.auditId,
        orgId: entry.orgId,
        workspaceId: entry.workspaceId,
        sequence,
        prevHash,
        actorUid: entry.actorUid,
        actorType: entry.actorType,
        actorRole: entry.actorRole ?? null,
        action: entry.action,
        resourceType: entry.resourceType,
        resourceId: entry.resourceId,
        version: entry.version ?? null,
        beforeSnapshot: canonicalizeAuditValue(entry.beforeSnapshot),
        afterSnapshot: canonicalizeAuditValue(entry.afterSnapshot),
        correlationId: entry.correlationId,
        timestamp: entry.timestamp,
    });
    return sha256Hex(canonicalPayload);
}
//# sourceMappingURL=audit-chain.js.map